import axios from "axios";
import { UNSAVE_JOB_POST_URL } from "../utils";

export const unsaveJobPost = async (jobPostId: string) => {
  return await axios.post(UNSAVE_JOB_POST_URL, {
    jobPostId,
  });
};
